import {
	pathOr,
	datetimeFormat,
} from '../helpers';

/**
 * แปลงข้อมูล audit log ให้เหมาะสำหรับการแสดงผล
 * @param {Object} audit - ข้อมูล audit log ต้นฉบับ
 *
 * ตัวอย่าง audit log ต้นฉบับ:
 * {
 *   id: 101,
 *   created_at: '2025-07-04T10:00:00Z',
 *   user: {
 *     username: 'john_doe',
 *     profile: {
 *       first_name: 'John',
 *       last_name: 'Doe',
 * 		 staff_id: '1234',
 *     },
 *   },
 *   event: 'updated',
 *   model_id: 55,
 *   model_type: 'User',
 *   ip_address: '192.168.1.1',
 *   user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
 *   old_values: {
 *     name: 'Old Name',
 *     status: 'inactive',
 *   },
 *   new_values: {
 *     name: 'New Name',
 *     status: 'active',
 *   },
 * }
 *
 * ผลลัพธ์หลังแปลง:
 * {
 *   id: 101,
 *   date: '04/07/2025 17:00',
 *   userName: 'john_doe',
 *   fullName: 'John Doe',
 *   staffId: '1234',
 *   event: 'updated',
 *   entityId: 55,
 *   entity: 'User',
 *   ipAddress: '192.168.1.1',
 *   userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
 *   entities: '(55) User',
 *   oldValues: { name: 'Old Name', status: 'inactive' },
 *   newValues: { name: 'New Name', status: 'active' },
 * }
 *
 * @returns {Object} - ข้อมูลที่ถูกแปลงแล้ว
 */
export const transformedAuditLog = (audit = {}) => {
	// ดึง id
	const id = pathOr(null, ['id'])(audit);

	// แปลงวันที่ ถ้าไม่มีให้ใช้ '-'
	const date = audit.created_at ? datetimeFormat(audit.created_at) : '-';

	// ข้อมูลผู้ใช้งาน
	const userName = pathOr(null, ['user', 'username'])(audit);
	const firstName = pathOr('', ['user', 'profile', 'first_name'])(audit);
	const lastName = pathOr('', ['user', 'profile', 'last_name'])(audit);
	const staffId = pathOr('-', ['user', 'profile', 'staff_id'])(audit);

	let fullName = `${firstName} ${lastName}`.trim();
	// ถ้าไม่มีชื่อและนามสกุล ให้แสดงเป็น '-'
	if (!firstName && !lastName) {
		fullName = '-';
	}


	// กิจกรรมที่เกิดขึ้น
	const event = pathOr(null, ['event'])(audit);

	// ข้อมูล entity (โมเดลที่ถูกกระทำ)
	const entityId = pathOr(null, ['model_id'])(audit);
	const entity = pathOr('', ['model_type'])(audit);
	const entities = `(${entityId}) ${entity}`;

	// ข้อมูลเพิ่มเติม
	const ipAddress = pathOr(null, ['ip_address'])(audit);
	const userAgent = pathOr(null, ['user_agent'])(audit);
	const oldValues = pathOr({}, ['old_values'])(audit);
	const newValues = pathOr({}, ['new_values'])(audit);

	return {
		id,
		date,
		userName,
		staffId,
		fullName,
		event,
		entityId,
		entity,
		ipAddress,
		userAgent,
		entities,
		oldValues,
		newValues,
	};
};

/**
 * แปลงรายการ audit logs หลายรายการ
 * @param {Array} audits - รายการ audit log
 * @returns {Array} - รายการ audit log ที่ถูกแปลงแล้ว
 */
export const transformedAuditLogList = (audits = []) => audits.map(transformedAuditLog);
